import { createStore, combineReducers } from 'redux';
import { roundReducer } from './reducers/roundReducer';
import { scoreReducer } from './reducers/scoreReducer';
import { infoReducer } from './reducers/infoReducer';
import { composeWithDevTools } from 'redux-devtools-extension';

const rootReducer = combineReducers({
  round: roundReducer,
  score: scoreReducer,
  info: infoReducer,
});

export const store = createStore(rootReducer, composeWithDevTools());
